import { picks } from "@/mocks/comicData";
import ComicCard from "@/components/feature/ComicCard";
import SectionHeading from "@/components/feature/SectionHeading";

export default function Picks() {
  return (
    <section id="picks" className="scroll-mt-16 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="编辑每周甄选"
          title="热门推荐 · 编辑精选"
          subtitle="编辑团队每周从人气与口碑中甄选值得一读的作品，从国风奇幻到科幻治愈，总有一部合你口味。"
        />

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {picks.map((comic, i) => (
            <ComicCard key={comic.id} comic={comic} badge={i === 0 ? "编辑精选" : "人气推荐"} />
          ))}
        </div>
      </div>
    </section>
  );
}